import { create } from "zustand";

const defaultValues = {
    id: "",
    title: "",
    isRejected: "",
    message: ""
}

interface IuseMessagePopup {
    isOpen: boolean,
    onOpen: (id: string, title: string, isRejected?: string, message?: string) => void,
    onClose: () => void
    initialValues: {
        id: string;
        title: string;
        isRejected?: string
        message?: string
    }
}

export const useMessageModel = create<IuseMessagePopup>((set) => ({
    isOpen: false,
    onOpen: (id, title, isRejected?, message?) => set({
        isOpen: true,
        initialValues: { id, title, isRejected, message }
    }),
    onClose: () => set({
        isOpen: false,
        initialValues: defaultValues
    }),
    initialValues: defaultValues
}))
